<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                v-if="numSlides"
                :value="selectedSlide"
                :options="slideOptions"
                native
                @input="onSlideSelection"
            />
        </template>

        <template slot="primary">
            <dropdown-custom
                class="gradient-dropdown"
                :value="selectedGradient"
                :options="options"
                @input="onInput"
            >
                <template v-slot="slotProps">
                    <div v-if="slotProps.value" class="gradient-dropdown__preview" :style="addTransparencyCheckerboardStyles(slotProps.value)" />
                    <div v-else class="gradient-dropdown__empty" />
                </template>
            </dropdown-custom>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { gradientStyleByName } from '@/utils/css';
import checkerboardPattern from '@/assets/ui/checkerboard-pattern.png';

export default {
    name: 'background-gradients',
    mixins: [baseOption],

    data() {
        return {
            gradientStyleByName,
            displayName: 'Background Gradients',
            selectedGradient: '',
            selectedSlide: 1,
        };
    },

    computed: {
        options() {
            const noneOption = [{ text: 'None', value: '' }];
            const gradientOptions = this.settings.gradients.map(gradient => ({ text: gradient.displayName, value: gradient.name }));

            return noneOption.concat(gradientOptions);
        },

        gradients() {
            const element = this.selectedElements[0];

            if (element.hasElementData('gradients')) {
                return element.getElementData('gradients');
            }

            return [];
        },

        numSlides() {
            return this.selectedElements[0].numSlides;
        },

        slideOptions() {
            return Array(...Array(this.numSlides)).map((x, i) => {
                return {
                    text: `Slide ${ i + 1 }`,
                    value: i + 1,
                };
            });
        },
    },

    methods: {
        onInput(newValue) {
            this.selectedGradient = newValue;

            const gradientsNew = Array.from(this.gradients);
            gradientsNew[this.selectedSlide - 1] = newValue;

            this.selectedElements[0].setElementData('gradients', gradientsNew);
            this.onOptionChange(newValue);
        },

        onSlideSelection(slideNum) {
            this.selectedSlide = +slideNum;
            this.selectedGradient = this.gradients[slideNum - 1];
        },

        onSelectedElement() {
            this.selectedSlide = 1;
            this.selectedGradient = this.gradients[0];
        },

        addTransparencyCheckerboardStyles(value) {
            const appendedCheckerboardStyles = gradientStyleByName(value);
            appendedCheckerboardStyles['background-image'] += `, url('${ checkerboardPattern }')`;
            appendedCheckerboardStyles['background-repeat'] = 'repeat';

            return appendedCheckerboardStyles;
        },
    },
};
</script>
